// Application configuration
export const API_CONFIG = {
  baseURL: import.meta.env.DEV ? '/api-proxy' : 'https://api.nightsync.io',
  localAPI: '/api',
  websocketAPI: '/ws',
  
  timeout: 10000,
  
  retryAttempts: 3,
  retryDelay: 1000,
  
  withCredentials: true,
  
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
}

export const ENV_CONFIG = {
  development: {
    apiBaseURL: '/api-proxy',
    enableLogging: true,
    enableMockData: false,
  },
  production: {
    apiBaseURL: 'https://api.nightsync.io',
    enableLogging: false,
    enableMockData: false,
  }
}

export const getCurrentConfig = () => {
  return import.meta.env.DEV ? ENV_CONFIG.development : ENV_CONFIG.production;
}

export default API_CONFIG; 
